<template>
    <div class="motion-img">
        <img :src="src" v-if="src"/>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
    props:{
        src: String
    },
});
</script>

<style lang="less" scoped>
.motion-img{
    background-color: @white;
    border-radius: 100%;
    display: inline-flex;
    padding: 3px;
    img{
        width: 18px;
        filter: url(#mid-map-b3);
    }
}
</style>
